export const DashboardConstants = {
    CHANGE_PAGE: "CHANGE_PAGE", 
    CHANGE_TOTAL_NUMBER_OF_PAGES: "CHANGE_TOTAL_NUMBER_OF_PAGES", 
    SET_BUSY: "SET_BUSY", 
    SET_IDLE: "SET_IDLE", 
    CLOSE_DRAWER: "CLOSE_DRAWER", 
    OPEN_DRAWER: "OPEN_DRAWER"
} 


